import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';

import { AppService } from '../../app.service';
import { AccountService } from './../account.service';
import { UtilityFunctions } from './../../shared/utility-functions';
import { MessageEvent, HiddenFooter, LoaderEvent, OpenFrameEvent } from './../../shared/message.event';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';

@Component({
	selector: 'pending-invoice',
	templateUrl: './pending-invoice.component.html',
	styleUrls: ['./pending-invoice.component.css'],
	exportAs: 'pendingInvoice',
	providers: [LoaderEvent, AccountService]
})
export class PendingInvoice implements OnInit {
	private vendor;
	private timezoneOffset;
	private startDate;
	private endDate;
	private message = '';
	private stringConstants = CONSTANT_MESSAGES;
	private popUpMessage = '';
	private recordList = [];
	private vendorCurrency = '';
	private utilityFunctions = new UtilityFunctions();
	private windowHeight = window.innerHeight;
	private topNav = 56;
	private midNav = 180;
	private footer = 35;
	private container = 20;
	private height: any;
	private divHeight = 30;
	@Input() search = '';
	constructor(private loaderEvent: LoaderEvent, private appService: AppService, private accountService: AccountService) {
		this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
	}
	ngOnInit() {
		if (localStorage.getItem('vendor')) {
			this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
			this.timezoneOffset = this.vendor.timezoneOffset * -1;
			this.vendorCurrency = this.vendor.country == 'India' ? 'INR' : 'USD';
		}
		this.setDates();
		this.fetchPendingInvoices();
	}

	setDates() {
		let timeZoneDate = moment().utcOffset(this.timezoneOffset);
		let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = 0, minutes = 0;
		this.startDate = (new Date(year, month, date, hour, minutes));
		let eventEndDate = moment().add(6, 'days').utcOffset(this.timezoneOffset).set({ 'hour': 23, 'second': 59, 'minute': 59, 'millisecond': 0 });
		year = eventEndDate.year(), month = eventEndDate.month(), date = eventEndDate.date(), hour = eventEndDate.hour(), minutes = eventEndDate.minutes();
		this.endDate = (new Date(year, month, date, hour, minutes));
	}

	fetchPendingInvoices(popUpObj?) {
		this.message = '';
		this.startDate.setHours(0, 0, 0);
		this.endDate.setHours(23, 59, 59);
		const eventStart = moment(this.startDate).utcOffset(this.timezoneOffset, true);
		const eventEnd = moment(this.endDate).utcOffset(this.timezoneOffset, true);
		if (eventStart.isBefore(eventEnd)) {
			let reqObj = {
				vendorId: this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
				startDate: eventStart,
				endDate: eventEnd,
				filters: []
			}
			if (this.search) {
				reqObj.filters.push({
					type: 'search',
					values: this.search
				});
			} else {
				reqObj.filters = [];
			}
			let recordList = [];
			let recObj;
			let that = this;
			this.loaderEvent.fire(false);
			this.accountService.getPendingInvoice(reqObj).then((result: any) => {

				if (result.status == 'SUCCESS') {
					this.recordList = result.penaltyData.filter(function (rec: any) {
						rec.date = that.utilityFunctions.maketimeZoneOfsetDate(rec.createdAt).format('dddd, LL');
						rec.time = that.utilityFunctions.maketimeZoneOfsetDate(rec.createdAt).format('HH:mm');
						return rec;
					});
					this.loaderEvent.fire(true);
				} else {
					this.loaderEvent.fire(true);
				}
			});
		} else {
			if (popUpObj) {
				this.popUpMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MESSAGE;
				popUpObj.showChildModal();
			}
		}
	}

	showPaymentPopoup(manualInvoicePayment, item) {
		manualInvoicePayment.showChildModal(item, { vendorId: this.vendor._id, clubName: this.vendor.clubName, timezoneOffset: this.timezoneOffset });
	}


}


// WEBPACK FOOTER //
// ./src/app/account/pending-invoice/pending-invoice.component.ts